export default __webpack_public_path__ + "static/media/rpl9.a73e1dea.jpg";